import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function ArrowDownIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 14 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M13 10C13.3866 9.6134 13.3866 8.9866 13 8.6C12.6134 8.2134 11.9866 8.2134 11.6 8.6L8.00001 12.2L8.00001 0.999999C8.00001 0.447713 7.5523 -5.3745e-07 7.00001 -5.85733e-07C6.44773 -6.34015e-07 6.00001 0.447715 6.00001 0.999999L6.00001 12.2L2.40001 8.6C2.01341 8.2134 1.38661 8.2134 1.00001 8.6C0.613413 8.9866 0.613413 9.6134 1.00001 10L6.2929 15.2929C6.68343 15.6834 7.3166 15.6834 7.70712 15.2929L13 10Z" />
      </svg>
    </Icon>
  );
}
